export const siteSettings = {
  siteName: "Scalprex",
  siteLink: "https://scalprex.live",
  siteCropLink: "scalprex.live",
  appLink: "https://app.scalprex.live",
  supportEmail: "support@scalprex.live",
};
